/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import * as constants from './utils/constants.ts';

const { host } = window.location;
const environments = {
  dev: 'dev',
  test: 'tst', 
  prod: 'prod',
};

const getAzureRedirectUrl = () => {
  switch (true) {
    case host.includes('localhost'):
      return [constants.LOCALHOST_URL,constants.CAPS_AUTHORITY_DEV,constants.CAPS_INSTANCE_DEV,constants.CAPS_APPLICATION_ID_DEV];
    case host.includes(environments.dev):
      return [constants.DEV_URL,constants.CAPS_AUTHORITY_DEV,constants.CAPS_INSTANCE_DEV,constants.CAPS_APPLICATION_ID_DEV];
    case host.includes(environments.test):
      return [constants.TEST_URL,constants.CAPS_AUTHORITY_DEV,constants.CAPS_INSTANCE_DEV,constants.CAPS_APPLICATION_ID_DEV];
    case host.includes(environments.prod):
      return [constants.PROD_URL,constants.CAPS_AUTHORITY_PROD,constants.CAPS_INSTANCE_PROD,constants.CAPS_APPLICATION_ID_PROD];
    default:
      return [constants.DEV_URL,constants.CAPS_AUTHORITY_DEV,constants.CAPS_INSTANCE_DEV,constants.CAPS_APPLICATION_ID_DEV];
  }
};

// //uncomment when we have prod
// const tenant = isProd ? "gmb2cprod.onmicrosoft.com" : "gmb2ctest.onmicrosoft.com";
// const signInPolicy = "b2c_1a_seamlessmigration_signuporsignin";
// const applicationID = isProd ? "37185b2e-37ec-4b1a-b6d3-a49835f6343f" : "5ad7668e-0cf4-4ad0-ba73-323bb1e15581";
// const reactRedirectUri = getAzureRedirectUrl();
// const instance = isProd ? "https://custlogin.gm.com/" : "https://gmb2ctest.b2clogin.com/";
// const signInAuthority = `${instance}${tenant}/${signInPolicy}`;
// end of uncomment when we have prod

const [reactRedirectUri, authority, knownAuthorities, clientId] = getAzureRedirectUrl();
export const msalConfigCaps = {
  auth: {
    // authority: signInAuthority,
    authority: authority,
    clientId: clientId,
    redirectUri: reactRedirectUri,
    postLogoutRedirectUri: '/',
    knownAuthorities: [knownAuthorities],
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    allowRedirectInIframe: true,
  },
  response_types: ['code'],
};

export const loginRequestCaps = {
  scopes: ['openid', 'profile'],
  extraQueryParameters: {
    brand: 'GM',
    channel: 'lightreg',
    // requiredMissingInfo: true,
    ui_locales: 'en-US',
  },
};